import { VacantRentalObject } from './vacant-rental-object';

export class VacantRentalObjectDwelling extends VacantRentalObject {
  constructor() {
    super();
  }
}
